import {FC, useRef, useEffect, useState} from 'react'
import {shallowEqual, useSelector, connect, useDispatch, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen, disableSplashScreen} from '../../../../_metronic/layout/core'
import * as auth from './AuthRedux'
import {getUserByToken} from './AuthCRUD'
import {RootState} from '../../../../setup'
import axios from 'axios'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useLocation } from 'react-router-dom'

const mapState = (state: RootState) => ({auth: state.auth})
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsFromRedux> = (props) => {
  const didRequest = useRef(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const tokenByUrl = queryParams.get('token')
  const tokenExp = queryParams.get('exp')
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  const accessToken = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)
  const accessTokenLS = JSON.parse(localStorage.getItem('primus-key'))?.accessToken
  const customerInfo = useSelector(({auth}: any) => auth.customerInfo)
  

  // Listen for logout in other tabs
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      // Detect logout from another tab (primus-key removed or primus-auth cleared)
      if (event.key === 'primus-key' && event.newValue === null) {
        dispatch(auth.actions.isTokenExp(true))
      }
      // Also check if redux-persist storage was cleared (for users without "remember me")
      if (event.key === 'persist:primus-auth' && event.newValue) {
        const authState = JSON.parse(event.newValue)
        if (authState.accessToken === 'undefined' || authState.accessToken === undefined) {
          dispatch(auth.actions.isTokenExp(true))
        }
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [dispatch])

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const requestUser = async (tokenByUrl) => {
      try {
        if (!didRequest.current) {
          const user = await getUserByToken(tokenByUrl ? tokenByUrl : accessTokenLS ? accessTokenLS : accessToken ? accessToken as string : '')
          .catch(error => {
            if(error?.response?.status === 401){
              dispatch(auth.actions.isTokenExp(true))
            }
          })
          dispatch(props.fulfillUser(user))
          if(tokenByUrl) {
            dispatch(auth.actions.login(tokenByUrl, false, parseFloat(tokenExp)))
            disableSplashScreen()
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          dispatch(props.logout())
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    if(!customerInfo?.portalMainLogo){
      let allUrl = window.location.origin
      let url = `${allUrl}/applet/v1/settings`.replace("portal", "api") 
      
      if(allUrl?.includes('portal')){
        axios.get(url).then((results) => {
          dispatch({
            type: auth.actionTypes.setCustomerInfo,
            payload: {
              portalMainLogo: results.data.data.results?.portalMainLogo || '/media/logos/ShipprimusLogoWhiteBG.png',
              portalBackground: results.data.data.results?.portalBackground.includes('#') ? results.data.data.results?.portalBackground : results.data.data.results?.portalBackground ? `url(${results.data.data.results?.portalBackground})` : `url(${toAbsoluteUrl('/media/background/Default-BGImage.jpg')})`,
              isDark: results.data.data.results?.isDark,
              announcementColorBackground: results.data.data.results?.announcementColorBackground,
              announcementColorText: results.data.data.results?.announcementColorText,
              announcementShowMode: results.data.data.results?.announcementShowMode,          
              customFavIcon: results.data.data.results?.customFavIcon || '/defaultFavicon.ico',
              loginWindowPositionPortal: results.data.data.results?.loginWindowPositionPortal,
              customerId: results.data.data.results?.internalReference,
              appletLoginNotes: results.data.data.results?.appletLoginNotes
            }
          })
          if(!tokenByUrl) {
            disableSplashScreen()
          }
        }).catch((error) => {
          dispatch({
            type: auth.actionTypes.setCustomerInfo,
            payload: {
              portalMainLogo: '/media/logos/ShipprimusLogoWhiteBG.png',
              portalBackground: `url(${toAbsoluteUrl('/media/background/Default-BGImage.jpg')})`,
              isDark: true,
              customFavIcon: '/defaultFavicon.ico'
            }
          })
          disableSplashScreen()
        })
      }else{
        dispatch({
          type: auth.actionTypes.setCustomerInfo,
          payload: {
            portalMainLogo: '/media/logos/ShipprimusLogoWhiteBG.png',
            portalBackground: `url(${toAbsoluteUrl('/media/background/Default-BGImage.jpg')})`,
            isDark: true,
            customFavIcon: '/defaultFavicon.ico'
          }
        })
        if(!tokenByUrl) {
          disableSplashScreen()
        }
      }
    }
    if((tokenByUrl && !accessToken) || (accessToken && tokenByUrl !== accessToken)) {
      // dispatch(auth.actions.register(tokenByUrl))
      requestUser(tokenByUrl)
    }

    if ((accessTokenLS) && !tokenByUrl) {
      requestUser(null)
    } else if (!tokenByUrl) {
      dispatch(props.logout())
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
